export const PANEL_WIDTH_STORAGE_KEY = 'neo-chat-panel-width';
export const MIN_PANEL_WIDTH = 380;
export const PANEL_STOPS = ['min', 'default', 'wide', 'full'];

export function widthForStop(stop) {
  if (typeof window === 'undefined') return 680;
  const vw = window.innerWidth;
  switch (stop) {
    case 'min':
      return MIN_PANEL_WIDTH;
    case 'wide':
      return Math.round(vw * 0.65);
    case 'full':
      return Math.round(vw * 0.92);
    default:
      return Math.min(680, Math.round(vw * 0.45));
  }
}

/** Nearest stop for an arbitrary dragged width, so the buttons stay in sync. */
export function nearestStop(width) {
  return PANEL_STOPS.reduce(
    (best, stop) =>
      Math.abs(widthForStop(stop) - width) < Math.abs(widthForStop(best) - width) ? stop : best,
    'default',
  );
}

export function defaultPanelWidth() {
  return widthForStop('default');
}

export function maxPanelWidth() {
  return widthForStop('full');
}

export function clampPanelWidth(width) {
  const n = Number(width);
  if (!Number.isFinite(n)) return defaultPanelWidth();
  return Math.min(maxPanelWidth(), Math.max(MIN_PANEL_WIDTH, Math.round(n)));
}

export function readStoredPanelWidth() {
  if (typeof window === 'undefined') return defaultPanelWidth();
  try {
    const stored = localStorage.getItem(PANEL_WIDTH_STORAGE_KEY);
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!Number.isNaN(parsed)) return clampPanelWidth(parsed);
    }
  } catch {
    // ignore
  }
  return defaultPanelWidth();
}

export function persistPanelWidth(width) {
  try {
    localStorage.setItem(PANEL_WIDTH_STORAGE_KEY, String(clampPanelWidth(width)));
  } catch {
    // ignore
  }
}
